import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      setStatus("Lösenord måste vara minst 8 tecken.");
      return;
    }
    try {
      await api.post(`/auth/reset?token=${encodeURIComponent(token)}`, { newPassword });
      setStatus("Lösenord återställt! Du kan nu logga in.");
    } catch {
      setStatus("Återställning misslyckades.");
    }
  };

  if (!token) {
    return (
      <div className="container">
        <p className="text-danger">Ingen återställningstoken angiven.</p>
      </div>
    );
  }

  return (
    <div className="container mt-3" style={{ maxWidth: 420 }}>
      <h3 className="mb-3">Återställ lösenord</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Nytt lösenord</label>
          <input
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary w-100">Spara nytt lösenord</button>
      </form>
      {status && <div className="alert alert-info mt-3">{status}</div>}
    </div>
  );
}
